import React from 'react'
import Services from '../components/Pricing'

export default function Prices() {
  return (
    <><Services></Services></>
  )
}
